/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as u from "react";
import { DropDownList as g } from "@progress/kendo-react-dropdowns";
import { applyInlineStyle as S, getInlineStyles as z } from "@progress/kendo-editor-common";
import { itemRender as w, userSelectNone as x } from "./utils.mjs";
import { registerForLocalization as I, provideLocalizationService as D } from "@progress/kendo-react-intl";
import { messages as K } from "../messages/index.mjs";
var d;
((f) => {
  f.createStyleDropDownList = (o) => {
    const s = class extends u.Component {
      constructor() {
        super(...arguments), this.onChange = (l) => {
          const a = l.target.value, { view: e } = this.props, { style: i } = o;
          if (e) {
            S({ style: i, value: a.value }, o.commandName)(e.state, e.dispatch);
            const { syntheticEvent: n } = l;
            n && n.type === "click" && e.focus();
          }
        };
      }
      render() {
        const { style: l } = o, { view: a, render: e, data: i, defaultItem: n, ...y } = this.props, c = i || o.items;
        let t = n || o.defaultItem;
        const m = a ? z(a.state, { name: l, value: /^.+$/ }) : [], v = D(this);
        t && t.localizationKey && (t = { ...t }, t.text = t.localizationKey ? v.toLanguageString(
          t.localizationKey,
          K[t.localizationKey]
        ) : t.text);
        const r = new Set(m).size === 1 ? m[0] : null, p = /* @__PURE__ */ u.createElement(
          g,
          {
            value: r && c.find((h) => h.value === r),
            data: c,
            defaultItem: t,
            itemRender: w,
            textField: "text",
            dataItemKey: "value",
            onChange: this.onChange,
            style: x,
            leftRightKeysNavigation: !1,
            title: t.text,
            ...y
          }
        );
        return e ? e.call(void 0, p, { view: a }) : p;
      }
    };
    return I(s), s;
  };
})(d || (d = {}));
export {
  d as FontStyleToolNS
};
